import React from 'react'

import { CSS } from '@dnd-kit/utilities'
import { useSortable } from '@dnd-kit/sortable'

import DndBlock, { DndBlockProps } from '../DndBlock'

interface DndSortableBlockProps extends DndBlockProps {
  id: string
}

const DndSortableBlock = (props: DndSortableBlockProps) => {
  const { children, disabled, editable, id, orientation, sx, ...rest } = props

  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({
    disabled: disabled,
    id: id
  })

  const style = {
    opacity: isDragging ? 0 : undefined,
    transform: CSS.Transform.toString(transform),
    transition
  }

  return (
    <DndBlock
      disabled={disabled}
      editable={editable}
      listeners={listeners}
      orientation={orientation}
      ref={setNodeRef}
      style={style}
      sx={sx}
      {...attributes}
      {...rest}
    >
      {children}
    </DndBlock>
  )
}

DndSortableBlock.displayName = 'DndSortableBlock'
export default DndSortableBlock
